import React from 'react';

// eslint-disable-next-line arca/no-default-export,no-empty-pattern,@typescript-eslint/no-empty-function
export default React.createContext(({}) => {});
